import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import NewPaymentForm from '../components/NewPaymentForm.js';
import { Box, Button, IconButton } from '@mui/material';
import axios from 'axios';
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentsPrint from '../components/PaymentsPrint.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PaymentsPage = () => {

  const [isNewPaymentFormOpen, setisNewPaymentFormOpen] = useState(false);
  let [selectedRow, setSelectedRow] = useState(null);
  let [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedRowDataPreview, setSelectedRowDataPreview] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpen2, setIsPopupOpen2] = useState(false);
  const [recentCreated, setrecentCreated] = useState(null);

  const [data, setData] = useState([]);
  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])


  // Function to open the form
  const openNewPaymentForm = () => {
    setisNewPaymentFormOpen(true);
    setSelectedRowData(null);
  };

  // Function to close the form
  const closeNewPaymentForm = () => {
    setisNewPaymentFormOpen(false);
  };

  const delete_payment = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/payments/delete_payment`, {
        data: {
          id: id
        }
      })
      if (response.status === 200) {
        toast.success(`Payment with id: "${id}" deleted successfully.`)
      }
    } catch (error) {
      toast.error("Error deleting payment")
    }
  }


  useEffect(() => {
    const fetch_payments = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/payments/all_payments`);
        const responseData = await response.json();
        if (responseData) {
          setData(responseData.payment);
          if(recentCreated !== null) {
            const RowFind = (responseData.payment).find((row)=>row.id === recentCreated);
            setSelectedRowDataPreview(RowFind)
            setIsPopupOpen2(true)
          } 
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    fetch_payments();
  }, [isNewPaymentFormOpen,recentCreated])


  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Payment Id',
        size: 100,
      },
      {
        accessorKey: 'clientid', //access nested data with dot notation
        header: 'Client Id',
        size: 100,
      },
      {
        accessorKey: 'clientinvoice', //access nested data with dot notation
        header: 'Client/Invoice',
        size: 100,
      },
      {
        accessorKey: 'paymentdate',
        header: 'Payment Date',
        size: 100,
      },
      {
        accessorKey: 'paymenttype', //normal accessorKey
        header: 'Payment Type',
        size: 200,
      },
      {
        accessorKey: 'type', //normal accessorKey
        header: 'Type',
        size: 200,
      },
      {
        accessorKey: 'amountstatus',
        header: 'Amount/Status',
        size: 100,
      },
      {
        accessorKey: 'status',
        header: 'Status',
        size: 100,
      },
      {
        accessorKey: 'notes',
        header: 'Notes',
        size: 100,
      }
    ],
    [],
  );

  const createdID = (id) => {
    setrecentCreated(id)
    console.log(id)
    closeNewPaymentForm()

  }

  return (
    <>
      <StickyTitle title="Client Receiving" button_action={openNewPaymentForm} button="New Receiving" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className=' px-4 lg:px-5 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
        <div className="table-filters flex flex-row items-center justify-between mt-3 mb-3">
          <div className='text-2xl ml-5 font-bold font-poppins flex items-center'>All Client Receiving<button onClick={openNewPaymentForm} className='px-3 py-0 text-3xl rounded bg-[#37a703] text-white font-bold font-poppins ml-2 sm:block hidden'>+</button></div>
          <NewPaymentForm isOpen={isNewPaymentFormOpen} onClose={closeNewPaymentForm} selectedRowData={selectedRowData} createdID={createdID} />
        </div>

        {data ? (<div className="w-full">
          <MaterialReactTable
            enableRowActions
            enableRowSelection
            columns={columns}
            data={data}
            renderRowActions={({ row }) => (
              <Box>
                <IconButton onClick={() => {
                  let rowData = row.original;
                  setSelectedRowDataPreview(rowData)
                  setIsPopupOpen(true);
                }}>
                  <ReceiptIcon />
                </IconButton>
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.id;
                  setSelectedRow(selectedRow);
                  alert('Deleting Payment with ID: ' + selectedRowId);
                  delete_payment(selectedRowId)

                } else {
                  alert('Please select a single row to delete.');
                }
              };
              const handleEdit = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  const selectedRow = selectedRows[0];
                  selectedRowData = selectedRow.original;
                  setSelectedRowData(selectedRowData);
                  setisNewPaymentFormOpen(true); // Open the form
                } else {
                  alert('Please select a single row to Edit.');
                }
              };


              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Delete
                  </Button>
                  <Button
                    color="success"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleEdit}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Edit
                  </Button>
                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>) : (null)}
      </div>

      <div>
        {isPopupOpen && (
          <div style={{
            display: isPopupOpen ? 'block' : 'none',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            height: '90vh',
            overflowY: 'auto',
            width: '800px'
          }}>

            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
              onClick={() => setIsPopupOpen(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <PaymentsPrint
            client={selectedRowDataPreview.clientinvoice}
            clientId={selectedRowDataPreview.clientid}
            paymentNumber={selectedRowDataPreview.id}
            paymentDate={selectedRowDataPreview.paymentdate}
            paymentAmount={selectedRowDataPreview.amountstatus}
            notes={selectedRowDataPreview.notes}
            status={selectedRowDataPreview.status}
            clientpay={true}
            chequenumber={selectedRowDataPreview.chequenumber}
            refnumber={selectedRowDataPreview.refnumber}
            type={selectedRowDataPreview.paymenttype}
            />

          </div>
        )}
      </div>
      <div>
        {isPopupOpen2 && (
          <div style={{
            display: isPopupOpen2 ? 'block' : 'none',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            height: '90vh',
            overflowY: 'auto',
            width: '800px'
          }}>

            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
              onClick={() => {setIsPopupOpen2(false); setrecentCreated(null)}}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <PaymentsPrint
              client={selectedRowDataPreview.clientinvoice}
              clientId={selectedRowDataPreview.clientid}
              paymentNumber={selectedRowDataPreview.id}
              paymentDate={selectedRowDataPreview.paymentdate}
              paymentAmount={selectedRowDataPreview.amountstatus}
              notes={selectedRowDataPreview.notes}
              status={selectedRowDataPreview.status}
              clientpay={true}
              chequenumber={selectedRowDataPreview.chequenumber}
              refnumber={selectedRowDataPreview.refnumber}
              type={selectedRowDataPreview.paymenttype}
            />

          </div>
        )}
      </div>

    </>
  );
};

export default PaymentsPage;
